import { gql } from "@apollo/client";

export const CREATE_FAV = gql`
  mutation createFav($fav: Int!) {
    User {
      createFav(fav: $fav) {
        listings
      }
    }
  }
`;

export const DELETE_FAV = gql`
  mutation deleteFav($fav: Int!) {
    User {
      deleteFav(fav: $fav) {
        listings
      }
    }
  }
`;
